import React, { useState, useEffect, useCallback } from 'react';
import { Header , Footer } from 'components';
import { Routes, Route } from 'react-router-dom';
import Modal from 'react-modal';
import Home from './Home/Home';
import Contact from './Contact/Contact';
import Account from './Account/Account';
import Products from './Products/Products';
import Orders from './Orders/Orders';
import Payment from './Payment/Payment';
import AutoLogin from './AutoLogin/AutoLogin';
import ProtectedContent from '../components/ProtectedContent/ProtectedContent';
import Cgv from './Cgv/Cgv';
import Faq from './Faq/Faq';
import MyAccount from './MyAccount/MyAccount';
import TutorialDelivery from './TutorialDelivery/TutorialDelivery';
import InactivityHandler from 'components/InactivityHandler/InactivityHandler';
import Tutorial from '../components/Tutorial/Tutorial';
import { TutorialProvider } from '../contexts/TutorialContext';
import user from 'services/store/User';

Modal.setAppElement('#root');

const App = () => {
  const [token, setToken] = useState();

  // Callback appelé à la fin du tutoriel
  const handleTutorialComplete = useCallback(() => {
    // Ce callback sera appelé quand le tutoriel se termine
    // L'ouverture de la modal de livraison sera gérée par le composant Products
    console.log('Tutoriel terminé');
  }, []);

  useEffect(() => {
    const tokenString = sessionStorage.getItem('token');

    //check token validity
    if (tokenString) {
      setToken(tokenString);
    }
  }, []);

  return (
    <div className="App">
      {token ? (
        <TutorialProvider onTutorialComplete={handleTutorialComplete}>
          <Header token={token} setToken={setToken} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/new-account" element={<Account />} />
            <Route path="/cgv" element={<Cgv />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/auto-login" element={<AutoLogin setToken={setToken} />} />
            <Route path="/products" element={
              <ProtectedContent token={token} setToken={setToken}>
                <Products token={token} />
              </ProtectedContent>
            }/>
            <Route path="/my-account" element={
              <ProtectedContent token={token} setToken={setToken}>
                <MyAccount token={token} />
              </ProtectedContent>
            }/>
            <Route path="/orders" element={
              <ProtectedContent token={token} setToken={setToken}>
                <Orders token={token} />
              </ProtectedContent>
            }/>
            <Route path="/payment" element={
              <ProtectedContent token={token} setToken={setToken}>
                <Payment token={token} />
              </ProtectedContent>
            }/>
            <Route path="/tutorial-delivery" element={
              <ProtectedContent token={token} setToken={setToken}>
                <TutorialDelivery />
              </ProtectedContent>
            } />
          </Routes>
          <Tutorial />
        </TutorialProvider>
      ) : (
        <>
          <Header token={token} setToken={setToken} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/new-account" element={<Account />} />
            <Route path="/cgv" element={<Cgv />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/auto-login" element={<AutoLogin setToken={setToken} />} />
            <Route path="/products" element={
              <ProtectedContent token={token} setToken={setToken}>
                <Products token={token} />
              </ProtectedContent>
            }/>
            <Route path="/my-account" element={
              <ProtectedContent token={token} setToken={setToken}>
                <MyAccount token={token} />
              </ProtectedContent>
            }/>
            <Route path="/orders" element={
              <ProtectedContent token={token} setToken={setToken}>
                <Orders token={token} />
              </ProtectedContent>
            }/>
            <Route path="/payment" element={
              <ProtectedContent token={token} setToken={setToken}>
                <Payment token={token} />
              </ProtectedContent>
            }/>
            <Route path="/tutorial-delivery" element={
              <ProtectedContent token={token} setToken={setToken}>
                <TutorialDelivery />
              </ProtectedContent>
            } />
          </Routes>
        </>
      )}
      <InactivityHandler logout={user.logoutUser} setToken={setToken} />
      <Footer />
    </div>
  );
}

export default App;
